import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-Left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_5 = { class: "header-Right" }
const _hoisted_6 = { class: "header-Right-Box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " 可生成视频:", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("条 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("兑换码兑换更多")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "header-Right-Border" }, null, -1)
const _hoisted_11 = { class: "header-Right-User" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "请问是否退出?", -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "exchangeBox" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", null, " 请输入兑换码，兑换商品视频权益 ", -1)
const _hoisted_18 = { class: "title" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("兑换成功")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 兑换失败，请重新输入 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 请输入兑换码 ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "dhtitle" }, "*每一个兑换码仅有一次使用机会", -1)
const _hoisted_23 = { class: "createBtn" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("兑换")
const _hoisted_25 = { class: "outbox" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_27 = { class: "zhezhaoBox" }

import router from '@/router';
import { ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { ElMessageBox, ElMessage } from 'element-plus';
import Api from '@/api';

export default /*#__PURE__*/_defineComponent({
  emits: ['updataShow'],
  setup(__props, { emit }) {

const store = useStore();

const exchange = ref(false);
const input = ref('');
const isOutBox = ref(false);
const yesAlt = ref(false);
const noAlt = ref(false);
const outLogin = ref(false);
const isShow = ref(false);
const noInput = ref(false);
const classYes = ref(true);
let balanceObj = ref({});
const updataShow = () => {
    // sessionStorage.setItem('comShow', 'Excess');
    store.commit('comShow/upDataShow', 'Excess');
    // emit('updataShow', 'Excess');
};
const toTop = () => {
    store.commit('comShow/upDataShow', 'Excess');
};

onMounted(() => {
    // eslint-disable-next-line no-use-before-define
    getBalance();
    window.addEventListener('click', handleClick);
});
const handleClick = (event: MouseEvent) => {

    if (!event.target.closest('.outdiv')) {
        // 在此处添加不是点击当前弹框的处理逻辑
        classYes.value = false;
        setTimeout(() => {
            classYes.value = true;

        }, 1000);
    }
};

//获取账户余额 视频数量
const getBalance = async () => {
    let result = await Api.Balance.getUserBalance();

    balanceObj.value = result.data;
};

//退出登陆
const outLoginFn = () => {
    // 打开弹框
    isOutBox.value = true;
    outLogin.value = false;
};
//确认退出登陆
const outLoginBtn = () => {
    isOutBox.value = false;
    router.push('/');
};
//取消退出登陆
const noLoginBtn = () => {
    isOutBox.value = false;

};
const open = () => {
    outLogin.value = true;
};

//兑换按钮点击
const dhBtn = async () => {
    yesAlt.value = false;
    noAlt.value = false;
    if (!input.value) {
        noInput.value = true;
        setTimeout(() => {
            noInput.value = false;
        }, 2000);
        return false;
    }
    let result = await Api.Balance.exchangeNum(input.value);

    if (!result.error) {
        yesAlt.value = true;

        setTimeout(() => {
            yesAlt.value = false;

        }, 3000);
    } else {
        noAlt.value = true;

        setTimeout(() => {
            noAlt.value = false;
        }, 3000);
    }

};


return (_ctx: any,_cache: any) => {
  const _component_font = _resolveComponent("font")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updataShow())),
          src: require('../assets/image/logo.jpg'),
          alt: ""
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("p", { onClick: toTop }, "AI商品视频助手")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _hoisted_7,
            _createVNode(_component_font, { style: {"font-weight":"bold"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(balanceObj).video), 1)
              ]),
              _: 1
            }),
            _hoisted_8
          ]),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (exchange.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: require('../assets/image/user.png'),
            alt: ""
          }, null, 8, _hoisted_12),
          _createVNode(_component_el_icon, { onClick: open }, {
            default: _withCtx(() => [
              _createVNode(_component_CaretBottom)
            ]),
            _: 1
          })
        ])
      ]),
      (isOutBox.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(classYes.value ? 'outdiv yesOutLogin' : 'outdiv yesOutLoginAnms')
          }, [
            _hoisted_13,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _withModifiers(outLoginBtn, ["stop"])
              }, "退出", 8, _hoisted_14),
              _createElementVNode("button", {
                onClick: _withModifiers(noLoginBtn, ["stop"])
              }, "返回", 8, _hoisted_15)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_dialog, {
        modelValue: exchange.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (exchange.value = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("p", null, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Select)
                ]),
                _: 1
              }),
              _hoisted_19
            ], 512), [
              [_vShow, yesAlt.value]
            ]),
            _withDirectives(_createElementVNode("p", null, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 1
              }),
              _hoisted_20
            ], 512), [
              [_vShow, noAlt.value]
            ]),
            _withDirectives(_createElementVNode("p", null, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 1
              }),
              _hoisted_21
            ], 512), [
              [_vShow, noInput.value]
            ])
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (input.value = $event)),
            placeholder: "请输入兑换码，兑换数字权益"
          }, null, 512), [
            [_vModelText, input.value]
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              onClick: dhBtn,
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_el_dialog, {
        top: "8vh",
        modal: false,
        "show-close": isShow.value,
        onClick: outLoginFn,
        modelValue: outLogin.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (outLogin.value = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_26
        ]),
        _: 1
      }, 8, ["show-close", "modelValue"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_27, null, 512), [
      [_vShow, isOutBox.value]
    ])
  ], 64))
}
}

})